module.exports = __webpack_public_path__ + "static/img/product-top-1.3d799603.png";